import React, { useEffect, useRef, useState } from 'react';
import { FaArrowRightLong } from "react-icons/fa6";
import SettingApi from '../api/SettingApi';
import ItemApi from '../api/ItemApi';
import TransactionApi from '../api/TransactionApi';
import SubscriptionApi from '../api/SubscriptionApi';
import UserApi from '../api/UserApi';


const Purchase = () => {
  const nonce = devsAccountingApi.nonce;
  const [invoiceType, setInvoiceType] = useState("person");
  const [settings, setSettings] = useState([]);
  const [item, setItem] = useState([]);
  const [paymentData, setPaymentData] = useState(null);
  const [user, setUser] = useState(null);
  const [loginCredentials, setLoginCredentials] = useState({
    username: '',
    password: ''
  });
  const userRef = useRef(null);
  const itemRef = useRef(null);
  const billingDataRef = useRef(null);
  const paymentDataRef = useRef(null)
  const price_id = Array.isArray(item.meta)
    ? (item.meta.find(meta => meta.meta_name === "paddle_price_id")?.meta_value || null)
    : null;
    
  const [loginError, setLoginError] = useState('');
  const [paddleLoaded, setPaddleLoaded] = useState(false);
  const [state, setState] = useState({
    paid_at: new Date().toISOString().split('T')[0],
    amount: item.sale_price,
    amountpaid: item.sale_price,
    description: '',
    type: '',
    category_id: item?.category_id,
    account_id: '',
    payment_method: '',
    data: null,
    transaction_id: null,
    nonce: nonce
  });

  const [billingData, setBillingData] = useState({
    invoiceType: "",
    name: "",
    address: "",
    city: "",
    zip: "",
    state: "",
    vat: "",
  });

  const [subscriptionData, setSubscriptionData] = useState({
    user_id: null,
    item_id: null,
    created_at: '',
    valid_till: '',
    license_key: '',
    site_limit: 2,
    billing_address: '',
    payment_data: '',
  });

  const [errors, setErrors] = useState({});

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const item_id = urlParams.get('item_id');

  const getItem = async () => {
    const res = await ItemApi.show(item_id);
    setItem(res);
  };

  const getSettings = async () => {
    const res = await SettingApi.index();
    setSettings(res);
  };


  const getUserBillingData = async () => {
    try {
      const userMeta = await UserApi.getUserMeta('billing_address');
      const billingData = userMeta.data; 
      setBillingData(billingData);
      setInvoiceType(billingData.invoiceType);
    } catch (error) {
      console.error('Error fetching user billing data:', error);
    }
  };
  

  const handleBillingChange = (e) => {
    setBillingData({ ...billingData, [e.target.name]: e.target.value });
  };

  const validateBilling = () => {
    let newErrors = {};
    if (!billingData.name) newErrors.name = "Name is required";
    if (!billingData.address) newErrors.address = "Address is required";
    if (!billingData.city) newErrors.city = "City is required";
    if (!billingData.zip) newErrors.zip = "ZIP is required";
    if (!billingData.state) newErrors.state = "State is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleInvoiceTypeChange = (e) => {
    const newInvoiceType = e.target.value;
    setInvoiceType(newInvoiceType);
    setBillingData({
      ...billingData,
      invoiceType: newInvoiceType,
    });
  };

  const getUser = async () => {
    try {
      const res = await UserApi.user();
      if (res.authenticated) {
        setUser(res);
      } else {
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  
  const handleLoginAndCheckout = async () => {
    if (!loginCredentials.username || !loginCredentials.password || !billingData) {
      setLoginError("Please enter both username and password.");
      return;
    }
  
    try {
      const loginRes = await UserApi.login(loginCredentials);
  
      if (loginRes && loginRes.authenticated) {
        setLoginError('');
      } else {
        setLoginError("Invalid username or password. Please try again.");
      }
    } catch (err) {
      setLoginError("An error occurred while logging in. Please try again.");
      console.error("Login error:", err);
    }
  };

  


  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const checkPaddle = setInterval(() => {
      if (window.Paddle) {
        clearInterval(checkPaddle);
        setPaddleLoaded(true);

        Paddle.Environment.set("sandbox");
        Paddle.Initialize({
          token: "test_ecc2cef6556bcfcde0f4a01a698",
          eventCallback: paddleSuccessCallback
        });
      }
    }, 500);
    return () => clearInterval(checkPaddle);
  }, []);


  useEffect(() => {
    if (paymentData) {
      setState((prevState) => {
        const updatedState = {
          ...prevState,
          data: paymentData,
          category_id: item.category_id,
          amount: item.sale_price,
          amountpaid: item.sale_price,
          type: "income",
          transaction_id: paymentData?.transaction_id,
          payment_method: paymentData.payment?.method_details?.type || "unknown",
        };
        return updatedState;
      });
    }
  }, [paymentData, item]);

  useEffect(() => {
    if (state.amount && state.type) {
      savePaymentToTransaction();
    }
  }, [state]);

  const savePaymentToTransaction = async () => {
    try {
      await TransactionApi.save(state);
    } catch (error) {
      console.error("Error saving transaction:", error);
    }
  };

  const handlePayment = async (priceId) => {
    if (!validateBilling()) return;
  
    if (!user || !item) {
      console.error('User or item data is missing!');
      return;
    }
    if (window.Paddle && window.Paddle.Checkout) {
      window.Paddle.Checkout.open({
        items: [{ priceId: priceId, quantity: 1, email: user?.user?.email, successCallback: paddleSuccessCallback }],
      });
    } else {
      console.error("Paddle Checkout is not loaded yet");
    }
  };
  
  useEffect(() => {
    if (item || user || billingData || paymentData) {
      itemRef.current = item;
      userRef.current = user;
      billingDataRef.current = billingData;
      paymentDataRef.current = paymentData;
    }
  }, [item, user, billingData]);

  const paddleSuccessCallback = (resdata) => {
 
    if (resdata?.name === 'checkout.completed') {
      const latestUser = userRef.current;
      const latestItem = itemRef.current;
      const latestBillingData = billingDataRef.current;
      const latestPaymentData = paymentDataRef.current;

      if (!latestUser) {
        console.error('User data is missing during checkout completion!');
        return;
      }

      if (!latestItem) {
        console.error('Item data is missing during checkout completion!');
        return;
      }
      setPaymentData(resdata.data);
      const updatedSubscription = {
        user_id: latestUser?.user?.ID,
        item_id: latestItem?.id,
        created_at: new Date().toISOString(),
        valid_till: '2026-10-30',
        billing_address: latestBillingData,
        site_limit: 2,
        payment_data: latestPaymentData,
      };
      setSubscriptionData(updatedSubscription);
      saveSubscription(updatedSubscription);
      
      location.pathname("/my-profile")
    
    } else {
    
    }
  };

  const saveSubscription = async (subscriptionData) => {
    try {
      const res = await SubscriptionApi.save(subscriptionData);
    } catch (error) {
      console.error("Error saving subscription:", error);
    }
  };

  useEffect(() => {
    getItem();
    getSettings();
    getUser();
    getUserBillingData()
  }, []);




  return (
    <div className='max-w-[1120px] mx-auto px-6 py-4'>
      <div className='flex justify-center sm:flex-col md:flex-col lg:flex-row border rounded-md shadow-sm min-h-[500px]'>
        <div className='sm:w-full md:w-full lg:max-w-[450px] px-6 py-4 lg:border-r border-gray-300 flex flex-col justify-center'>
          {!user ? (
            <div>
              <h2 className='text-lg font-semibold mt-3'>Sign in</h2>
         
              <form onSubmit={(e) => { e.preventDefault();  }} >
                <div className='flex justify-between items-center gap-4'>
                    <input 
                      type="text"
                      value={loginCredentials.username}
                      onChange={(e) => setLoginCredentials({ ...loginCredentials, username: e.target.value })}
                      placeholder='User Name/Email'
                      className='w-full border px-4 py-1 rounded-md placeholder:text-sm'
                      required
                    />
                    <input 
                      type="password"
                      value={loginCredentials.password}
                      onChange={(e) => setLoginCredentials({ ...loginCredentials, password: e.target.value })}
                      placeholder='Password'
                      className='w-full border px-4 py-1 rounded-md placeholder:text-sm'
                      required
                    />
                </div>
               
                {loginError && <p className='text-red-600 text-xs'>{loginError}</p>}
              </form>

              <p className='text-sm mb-2 mt-3'>
                Don't have an account? <a href={`${settings.home_url}/register`} className='hover:underline underline-offset-2 text-blue-700 font-semibold'>Sign up</a>
              </p>
            </div>
          ) : (
            <p className='text-green-600 font-semibold'>Welcome, {user?.user?.data?.display_name}!</p>
          )}
        <div className='my-6'>
            <h2 className='text-lg font-semibold'>Billing</h2>
            <form className='flex flex-col gap-4 mt-3'>
                <select  value={invoiceType} onChange={handleInvoiceTypeChange} className='text-black bg-white py-2 border rounded-md w-full px-3 text-sm'>
                  <option disabled selected>How do you wish to be invoiced</option>
                  <option value="person">As a person</option>
                  <option value="company">As a company</option>
                </select>
                <div>
                    <input name="name" value={billingData.name} onChange={handleBillingChange} required placeholder={invoiceType === "company" ? "Company Name" : "Name"} className='border px-4 py-2 rounded-md placeholder:text-sm text-sm w-full' />
                    {errors.name && <p className='text-red-500 text-xs mt-1'>{errors.name}</p>}
                </div>
                <div>
                    <input name="address" value={billingData.address} onChange={handleBillingChange} required placeholder={invoiceType === "company" ? "Company Address" : "Address"} className='border px-4 py-2 rounded-md placeholder:text-sm text-sm w-full' />
                    {errors.address && <p className='text-red-500 text-xs mt-1'>{errors.address}</p>}
                </div>
                <div className='flex justify-between gap-4'>
                <div>
                      <input name="city" value={billingData.city} onChange={handleBillingChange} placeholder='City' className='border px-4 py-2 rounded-md placeholder:text-sm text-sm w-full' />
                      {errors.city && <p className='text-red-500 text-xs mt-1'>{errors.city}</p>}
                </div>
                  <div>
                      <input name="zip" value={billingData.zip} onChange={handleBillingChange} placeholder='Zip' className='border px-4 py-2 rounded-md placeholder:text-sm text-sm w-full' />
                      {errors.zip && <p className='text-red-500 text-xs mt-1'>{errors.zip}</p>}
                  </div>
                </div>
                <div>
                    <input name="state" value={billingData.state} onChange={handleBillingChange} required placeholder='State' className='border px-4 py-2 rounded-md placeholder:text-sm text-sm w-full' />
                    {errors.state && <p className='text-red-500 text-xs mt-1'>{errors.state}</p>}
                </div>
                <input name="vat" value={billingData.vat} onChange={handleBillingChange} placeholder='VAT TIN/Tax Registration Number' className='border px-4 py-2 rounded-md placeholder:text-sm text-sm w-full' />
              </form>
        </div>
     
        </div>
        {/* Right side: Purchase Summary */}
        <div className='w-full px-6 py-4'>
          <div>
            <h2 className='text-lg font-semibold my-3'>Purchase</h2>
            <span className='block text-5xl font-bold my-2'>
              ${item?.sale_price} 
            </span>
          </div>
          <div className='flex justify-between items-start my-5 border-b py-1.5'>
            <div>
              <h5 className='text-[15px] capitalize font-semibold'>{item?.name} for 2 Site</h5>
              <p className='text-sm text-gray-500'>billed </p>
            </div>
            <p className='font-semibold text-[16px]'>${item?.sale_price}</p>
          </div>
          <div className='flex justify-between items-start my-5 border-b py-1.5'>
            <h5 className='text-[15px] capitalize font-semibold'>Total</h5>
            <p className='font-semibold text-[16px]'>${item?.sale_price}</p>
          </div>
          <div className='w-full flex flex-col gap-4 my-5 border-b bg-gray-100 min-h-[200px] border rounded-md p-4'>
        
         <p className='text-xs text-center px-6 mt-2'> By purchasing, you acknowledge that your subscription will be renewed annually, unless you switch to manual renewal.</p>
        <div className='flex flex-wrap gap-2 w-1/2 mx-auto'>
              <img className='w-full object-cover h-full'  src='/wp-content/plugins/devs-accounting/src/img/payments.jpeg' />
             
        </div>
        <button 
          onClick={async () => {
            await handleLoginAndCheckout();
            if (user && billingData && paddleLoaded) {
              handlePayment(price_id);
            }
          }}
          disabled={!paddleLoaded}
          type="submit" 
          className="bg-green-600 text-white px-4 py-2.5 text-center rounded-md text-lg w-full flex items-center justify-center gap-2"
        >
          Login And Checkout <FaArrowRightLong className="inline text-lg"/>
        </button>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Purchase;
